<template>
  <div class="message-box-bg flex-center" v-if="showMetamaskMessageBox">
    <div class="message-box">
      <div class="message-box-main">
        <div class="message-box-top">
          <h4 class="flex-center">
            {{ $t("home.walletConnect.messageBox.title") }}
          </h4>
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
        <div class="box-but flex-center">
          <i class="icon icon-metamask"></i> Connect MetaMask ...
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "MetamaskMessageBox",

  computed: {
    ...mapState({
      showMetamaskMessageBox: (state) =>
        state.connectWallet.showMetamaskMessageBox,
    }),
    aLink() {
      return process.env.VUE_APP_INVITE;
    },
  },
  methods: {
    ...mapMutations(["SET_SHOW_METAMASK"]),
    onShowMessageBox() {
      this.SET_SHOW_METAMASK(!this.showMetamaskMessageBox);
    },
  },
};
</script>
<style lang="scss" scoped>
.message-box-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.68);
  flex-direction: column;
  .message-box-main {
    padding: 24px 24px 40px;
    background: #1e1f23;
    border-radius: 20px;
  }
  .message-box {
    position: relative;
    width: 480px;
    background: #101314;
    border-radius: 24px;
    z-index: 9999;
    overflow: hidden;

    .message-box-gradient {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 40px;
      background-image: linear-gradient(90deg, #18eed8 1%, #a6f616 100%);
      border-radius: 24px;
      filter: blur(49px);
      z-index: 0;
    }
    .message-box-top {
      position: relative;
      margin-bottom: 40px;
      .icon-close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .box-but {
      min-width: 164px;
      max-width: 300px;
      margin: 24px auto;

      .icon {
        margin-right: 16px;
      }

      .text-download {
        font-size: 16px;
        margin-left: 8px;
      }
    }
  }
}
</style>
